import { federalCssStylesEnabled as isFederalInstance } from '@gonfalon/constants/constants';
import { sdkActiveMocking } from '@gonfalon/dogfood-flags/dogfood-flags';
import { getSdkInfoByKey, type SdkKey } from '@gonfalon/sdk-info/sdkInfo';
import { useQuery } from '@tanstack/react-query';

import { getSdkActiveQuery } from '../queries/usage';

export const useSdkActive = (
  { apiVersion, sdkKey }: { apiVersion?: string; sdkKey?: SdkKey } = {},
  options?: { enabled?: boolean; [key: string]: unknown },
) => {
  const sdkActiveMockingMode = sdkActiveMocking();

  let query;
  if (sdkKey) {
    const sdkMeta = getSdkInfoByKey(sdkKey);
    if (sdkMeta.wrapperName) {
      query = { sdk_wrapper_name: sdkMeta.wrapperName };
    } else {
      query = { sdk_name: sdkKey };
    }
  }

  return useQuery({
    ...getSdkActiveQuery({ apiVersion, query }),
    ...options,
    enabled: !isFederalInstance() && sdkActiveMockingMode === 'enabled' && options?.enabled !== false,
    placeholderData:
      sdkActiveMockingMode === 'true'
        ? { active: true }
        : sdkActiveMockingMode === 'false'
          ? { active: false }
          : undefined,
  });
};
